import {Component, inject}      from '@angular/core';
import {RouterOutlet}           from '@angular/router';
import {SwUpdate}               from '@angular/service-worker';
import {UiNotificationsService} from './lib/logr-ui/utils/ui-notifications.service';

@Component({
			   selector   : 'app-root',
			   imports    : [
				   RouterOutlet
			   ],
			   templateUrl: './app.component.html',
			   styleUrl: './app.component.css'
		   })
export class AppComponent {
	title = 'logr-web-patient';
	updates = inject(SwUpdate)
	notifications = inject(UiNotificationsService)

	constructor() {
		this.updates.versionUpdates.subscribe(e => {
			if (e.type === 'VERSION_READY') {
				this.notifications.showNotification('Loading new version...').then(() => {
					this.updates.activateUpdate().then(() => location.reload())
				})
			}
		});
	}


}
